import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaArrowRight, FaArrowLeft, FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import Footer from '../../Footer';
import NextSteps from '../../NextSteps';
import axios from 'axios';
import { store } from '../../../App';
import { apiUrl } from '../../Constants';
import LoaderComponent from '../../Loader';
import '../../../css/VehicleCategories.css';

const FOTON_FAMILY_BANNER_URL = "https://dev10.sbagh.com/public/images/gallery/large/1698822841-Foton-Family-2560-x-1395%20(1).jpg";
const FOTON_FAMILY_BANNER_FALLBACK = "/Images/Banners/foton-family-banner.jpg";
const CATEGORY_HERO_IMAGES = {
  pickup: "/Images/Banners/tunland-pickup.jpg",
};

// Only remap legacy/alternate slugs — never map a real category onto another
// (e.g. mini-truck must NOT alias to light-duty-trucks / aumark-s).
const SLUG_ALIASES = {
  'minitruck': 'mini-truck',
  'mini_truck': 'mini-truck',
  'bus': 'mini-bus',
  'minibus': 'mini-bus',
  'ev': 'special-vehicles',
  'mhdt': 'medium-and-heavy-duty-trucks',
  'medium-duty-truck': 'medium-and-heavy-duty-trucks',
  'heavy-duty-truck': 'medium-and-heavy-duty-trucks',
};

const BASE_CATEGORIES = [
  {
    id: 12,
    slug: "medium-and-heavy-duty-trucks",
    name_en: "Medium & Heavy Duty Trucks",
    name_ar: "الشاحنات المتوسطة والثقيلة",
    tag_en: "Heavy Haul & Infrastructure",
    tag_ar: "النقل الثقيل والبنية التحتية",
    desc_en: "AUMAN, a wide range covering medium and long-haul transportation, logistics, and heavy infrastructure.",
    desc_ar: "أومان، مجموعة واسعة تغطي النقل للمسافات المتوسطة والطويلة واللوجستيات والبنية التحتية.",
    image: "/Images/Card-img/AUMAN-EST-A-ICON.webp",
    features_en: ["AUMAN EST-A Series", "Heavy Logistics", "Superior Durability"],
    features_ar: ["سلسلة أومان EST-A", "اللوجستيات الثقيلة", "متانة فائقة"],
    targetLink: "/vehicles/medium-and-heavy-duty-trucks",
    btn_en: "EXPLORE TRUCKS",
    btn_ar: "استكشف الشاحنات",
    models_count_en: "4 Models",
    models_count_ar: "٤ طرازات",
    sort: 1
  },
  {
    id: 13,
    slug: "light-duty-trucks",
    name_en: "Light Duty Trucks",
    name_ar: "الشاحنات الخفيفة",
    tag_en: "Urban Logistics & Freight",
    tag_ar: "الخدمات اللوجستية والشحن الحضري",
    desc_en: "AUMARK S, urban transportation expert redefining logistics with European standard and advanced safety.",
    desc_ar: "أومارك إس، خبير النقل الحضري الذي يعيد تعريف الخدمات اللوجستية بمعايير السلامة والأداء الأوروبية.",
    image: "/Images/Card-img/AUMARK-S-ICON.webp",
    features_en: ["AUMARK S Series", "Euro Standards", "Smart Cabin"],
    features_ar: ["سلسلة أومارك S", "معايير أوروبية", "مقصورة ذكية"],
    targetLink: "/vehicles/light-duty-trucks",
    btn_en: "EXPLORE TRUCKS",
    btn_ar: "استكشف الشاحنات",
    models_count_en: "Aumark S",
    models_count_ar: "أومارك إس",
    sort: 2
  },
  {
    id: 18,
    slug: "mini-truck",
    name_en: "Mini Truck",
    name_ar: "شاحنة صغيرة",
    tag_en: "Agile City Cargo",
    tag_ar: "شحن تجاري خفيف للمدينة",
    desc_en: "Agile, efficient, and reliable commercial mini truck engineered for versatile urban logistics.",
    desc_ar: "شاحنة تجارية صغيرة رشيقة وفعالة وموثوقة مصممة للخدمات اللوجستية الحضرية المتنوعة.",
    image: "/Images/Card-img/MINI-TRUCK-ICON.webp",
    features_en: ["Compact Agility", "Low Fuel Consumption", "High Payload"],
    features_ar: ["مرونة فائقة", "استهلاك وقود اقتصادي", "حمولة عالية"],
    targetLink: "/vehicles/mini-truck",
    btn_en: "EXPLORE MINI TRUCK",
    btn_ar: "استكشف الشاحنة الصغيرة",
    models_count_en: "Commercial Cargo",
    models_count_ar: "شحن تجاري",
    sort: 3
  },
  {
    id: 14,
    slug: "pickup",
    name_en: "Pickup & 4x4",
    name_ar: "بيك أب ودفع رباعي",
    tag_en: "Lifestyle & Heavy Work",
    tag_ar: "أسلوب حياة واستخدام شاق",
    desc_en: "TUNLAND G7 - Rugged pickup and 4x4 power built for adventure lifestyles and demanding commercial tasks.",
    desc_ar: "تونلاند جي 7 - بيك أب قوي ودفع رباعي مصمم لمغامرات أسلوب الحياة واحتياجات الأعمال الشاقة.",
    image: "/Images/Card-img/TUNLAND-ICON0.webp",
    features_en: ["TUNLAND G7 Series", "4x4 All-Terrain", "Smart Tech & Luxury"],
    features_ar: ["سلسلة تونلاند G7", "دفع رباعي لكافة الطرق", "فخامة وتقنية ذكية"],
    targetLink: "/vehicles/pickup",
    btn_en: "EXPLORE PICKUP",
    btn_ar: "استكشف بيك أب",
    models_count_en: "Tunland Series",
    models_count_ar: "سلسلة تونلاند",
    sort: 4
  },
  {
    id: 19,
    slug: "van",
    name_en: "Van",
    name_ar: "فان",
    tag_en: "Cargo & Passenger Vans",
    tag_ar: "فانات الركاب والبضائع",
    desc_en: "Versatile, spacious passenger and cargo vans offering modern comfort, great efficiency, and maximum reliability.",
    desc_ar: "فانات ركاب وبضائع واسعة ومتعددة الاستخدامات توفر الراحة العصرية والكفاءة العالية والموثوقية القصوى.",
    image: "/Images/Card-img/VAN-ICON.webp",
    features_en: ["Spacious Interior", "Flexible Seating", "Economical Drive"],
    features_ar: ["مقصورة واسعة", "مقاعد مرنة", "قيادة اقتصادية"],
    targetLink: "/vehicles/van",
    btn_en: "EXPLORE VAN",
    btn_ar: "استكشف فان",
    models_count_en: "View & Toano",
    models_count_ar: "فيو وتوانو",
    sort: 5
  },
  {
    id: 20,
    slug: "mini-bus",
    name_en: "Mini Bus",
    name_ar: "حافلة صغيرة",
    tag_en: "Safe Passenger Shuttle",
    tag_ar: "نقل الركاب والرحلات",
    desc_en: "Safe, comfortable, and reliable passenger transportation for commercial transport, group travel, and shuttle services.",
    desc_ar: "نقل ركاب آمن ومريح وموثوق لنقل المجموعات والتنقل التجاري وخدمات التوصيل.",
    image: "/Images/Card-img/MINI-BUS-ICON.webp",
    features_en: ["Group Passenger Comfort", "Commercial Durability", "Advanced Safety"],
    features_ar: ["راحة الركاب", "متانة تجارية", "أمان متقدم"],
    targetLink: "/vehicles/mini-bus",
    btn_en: "EXPLORE MINI BUS",
    btn_ar: "استكشف حافلة صغيرة",
    models_count_en: "Commercial Shuttle",
    models_count_ar: "خدمة نقل تجارية",
    sort: 6
  }
];

const FALLBACK_CATEGORIES = {
  'mini-truck': {
    title: {
      menu_name_en: "MINI TRUCK",
      menu_name_ar: "شاحنات صغيرة",
    },
    content: [
      {
        id: 'wonder',
        product_name_en: "Wonder",
        product_name_ar: "يتعجب",
        product_image: "/Images/Card-img/MINI-TRUCK-ICON.webp",
        short_description_en: "Compact commercial mini truck built for agile urban logistics.",
        short_description_ar: "شاحنة تجارية صغيرة مدمجة مصممة للخدمات اللوجستية الحضرية المرنة.",
        product_name_slug: "wonder"
      }
    ]
  },
  'light-duty-trucks': {
    title: {
      menu_name_en: "LIGHT DUTY TRUCKS",
      menu_name_ar: "الشاحنات الخفيفة",
    },
    content: [
      {
        id: 'aumark-s',
        product_name_en: "AUMARK S",
        product_name_ar: "او مارك اس",
        product_image: "1699335198.webp",
        short_description_en: "AUMARK S - Redefining urban and regional logistics with European standard and advanced safety.",
        short_description_ar: "أومارك إس - إعادة تعريف الخدمات اللوجستية الحضرية والإقليمية بأمان وكفاءة معايير أوروبية.",
        product_name_slug: "aumark-s"
      }
    ]
  },
  'medium-and-heavy-duty-trucks': {
    title: {
      menu_name_en: "MEDIUM & HEAVY DUTY TRUCKS",
      menu_name_ar: "الشاحنات المتوسطة والثقيلة",
    },
    content: [
      {
        id: 'auman-est-a-tractor',
        product_name_en: "AUMAN EST-A TRACTOR",
        product_name_ar: "أومان إي إس تي - إيه قاطرة",
        product_image: "/Images/Card-img/AUMAN-EST-A-ICON.webp",
        short_description_en: "High-performance heavy-duty tractor designed for long-distance transport and massive payloads.",
        short_description_ar: "قاطرة ثقيلة عالية الأداء مصممة للنقل لمسافات طويلة والحمولات الضخمة.",
        product_name_slug: "auman-est-a-tractor"
      },
      {
        id: 'auman-est-dumper',
        product_name_en: "AUMAN EST DUMPER",
        product_name_ar: "أومان إي إس تي قلاب",
        product_image: "/Images/Card-img/AUMAN-EST-A-ICON.webp",
        short_description_en: "Rugged dump truck built for extreme construction sites, mining, and heavy materials hauling.",
        short_description_ar: "شاحنة قلاب متينة مصممة لمواقع البناء والتعدين ونقل المواد الثقيلة.",
        product_name_slug: "auman-est-dumper"
      },
      {
        id: 'auman-est-m',
        product_name_en: "AUMAN EST-M",
        product_name_ar: "أومان إي إس تي - إم",
        product_image: "/Images/Card-img/AUMAN-EST-A-ICON.webp",
        short_description_en: "Medium-duty truck offering optimal efficiency, maneuverability, and regional distribution power.",
        short_description_ar: "شاحنة متوسطة الحمولة توفر كفاءة مثالية وقدرة على المناورة والتوزيع الإقليمي.",
        product_name_slug: "auman-est-m"
      },
      {
        id: 'auman-etx',
        product_name_en: "AUMAN ETX",
        product_name_ar: "أومان إي تي إكس",
        product_image: "/Images/Card-img/AUMAN-EST-A-ICON.webp",
        short_description_en: "Time-tested heavy-duty truck recognized worldwide for reliability and tough working conditions.",
        short_description_ar: "شاحنة ثقيلة معتمدة عالمياً لموثوقيتها وقدرتها على العمل في أقسى الظروف.",
        product_name_slug: "auman-etx"
      }
    ]
  },
  'pickup': {
    title: {
      menu_name_en: "Pickup",
      menu_name_ar: "يلتقط",
    },
    content: [
      {
        id: 'tunland',
        product_name_en: "TUNLAND",
        product_name_ar: "تونلاند",
        product_image: "/Images/Card-img/TUNLAND-ICON0.webp",
        short_description_en: "Foton Tunland pickup built for work and lifestyle.",
        short_description_ar: "بيك أب فوتون تونلاند للعمل وأسلوب الحياة.",
        product_name_slug: "tunland"
      },
      {
        id: 'tunland-g7',
        product_name_en: "TUNLAND G7",
        product_name_ar: "تونلاند جي 7",
        product_image: "/Images/Card-img/TUNLAND-ICON0.webp",
        short_description_en: "Brand new pickup for enjoying life.",
        short_description_ar: "بيك أب جديد للاستمتاع بالحياة.",
        product_name_slug: "tunland-g7"
      }
    ]
  },
  'van': {
    title: {
      menu_name_en: "VAN",
      menu_name_ar: "فان",
    },
    content: [
      {
        id: 'view-cs2-2022',
        product_name_en: "VIEW CS2",
        product_name_ar: "فيو سي إس 2",
        product_image: "/Images/Card-img/VAN-ICON.webp",
        short_description_en: "High-capacity passenger and cargo van built for urban delivery, shuttles, and commercial travel.",
        short_description_ar: "فان ركاب وبضائع واسع مصمم للتوزيع الحضري والرحلات والنقل التجاري.",
        product_name_slug: "view-cs2-2022"
      },
      {
        id: 'toano',
        product_name_en: "TOANO",
        product_name_ar: "توانو",
        product_image: "/Images/Card-img/MINI-BUS-ICON.webp",
        short_description_en: "European-styling large van offering massive interior space and modern luxury comfort.",
        short_description_ar: "فان كبير بتصميم أوروبي يوفر مساحة داخلية شاسعة وراحة عصرية فاخرة.",
        product_name_slug: "toano"
      }
    ]
  },
  'mini-bus': {
    title: {
      menu_name_en: "MINI BUS",
      menu_name_ar: "حافلة صغيرة",
    },
    content: [
      {
        id: 'toano',
        product_name_en: "TOANO SHUTTLE",
        product_name_ar: "توانو حافلة ركاب",
        product_image: "/Images/Card-img/MINI-BUS-ICON.webp",
        short_description_en: "Safe, comfortable commercial shuttle bus for passenger travel, schools, and corporate fleets.",
        short_description_ar: "حافلة ركاب تجارية آمنة ومريحة لرحلات الركاب والمدارس وأساطيل الشركات.",
        product_name_slug: "toano"
      },
      {
        id: 'view-cs2-2022',
        product_name_en: "VIEW CS2 PASSENGER",
        product_name_ar: "فيو سي إس 2 ركاب",
        product_image: "/Images/Card-img/VAN-ICON.webp",
        short_description_en: "Reliable, comfortable 14-16 seater minibus for efficient city and regional passenger transit.",
        short_description_ar: "حافلة ركاب مريحة وموثوقة تتسع لـ 14-16 راكباً للنقل الجماعي داخل المدن والمحافظات.",
        product_name_slug: "view-cs2-2022"
      }
    ]
  },
  'special-vehicles': {
    title: {
      menu_name_en: "SPECIAL VEHICLES",
      menu_name_ar: "المركبات الخاصة",
    },
    content: [
      {
        id: 'fuel-tanker',
        product_name_en: "FUEL TANKER",
        product_name_ar: "ناقلة وقود",
        product_image: "/Images/Card-img/sp.png",
        short_description_en: "Dedicated specialized vehicle for safe and reliable fuel transport.",
        short_description_ar: "مركبة متخصصة لنقل الوقود بأمان وموثوقية.",
        product_name_slug: "fuel-tanker"
      },
      {
        id: 'water-tanker',
        product_name_en: "WATER TANKER",
        product_name_ar: "ناقلة مياه",
        product_image: "/Images/Card-img/sp.png",
        short_description_en: "Efficient heavy duty water transportation solution.",
        short_description_ar: "حل فعال لنقل المياه للخدمات الشاقة.",
        product_name_slug: "water-tanker"
      }
    ]
  }
};

const cleanHtml = (html) => {
  if (typeof html !== 'string') return '';
  return html.replace(/<[^>]*>?/gm, '').trim();
};

const isLocalEnv = () => {
  return typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
};

const getPublicAssetBase = () => {
  if (apiUrl && /^https?:\/\//i.test(apiUrl)) {
    try {
      return `${new URL(apiUrl).origin}/public`;
    } catch (e) {
      // fall through
    }
  }
  return 'https://dev10.sbagh.com/public';
};

const getProductImageUrl = (img) => {
  if (!img || typeof img !== 'string') return '/Images/Card-img/TUNLAND-ICON0.webp';
  const trimmed = img.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/')) {
    return trimmed;
  }
  if (trimmed.startsWith('auman_est_m_')) {
    return `/Images/products/auman-est-m/${trimmed}`;
  }
  return `${getPublicAssetBase()}/images/products/large/${trimmed}`;
};

const PRODUCT_CARD_IMAGES = {
  'medium-duty-truck': '/Images/Card-img/AUMAN-EST-A-ICON.webp',
  'medium-and-heavy-duty-trucks': '/Images/Card-img/AUMAN-EST-A-ICON.webp',
  'light-duty-trucks': '/Images/Card-img/AUMARK-S-ICON.webp',
  'mini-truck': '/Images/Card-img/MINI-TRUCK-ICON.webp',
  'pickup': '/Images/Card-img/TUNLAND-ICON0.webp',
  'van': '/Images/Card-img/VAN-ICON.webp',
  'mini-bus': '/Images/Card-img/MINI-BUS-ICON.webp',
};

const NON_VEHICLE_MENU_SLUGS = new Set([
  'showrooms-service',
  'showrooms',
  'service-centers',
  'show-rooms',
  'gulf-great-sands-llc',
]);

const VEHICLE_CATEGORY_SLUGS = new Set([
  'mini-truck',
  'van',
  'mini-bus',
  'pickup',
  'light-duty-trucks',
  'medium-duty-truck',
  'medium-and-heavy-duty-trucks',
  'special-vehicles',
]);

/** Same product image resolution as Navbar Products mega menu */
const getMenuProductImageSrc = (child) => {
  const slug = (child?.slug || '').toLowerCase();

  if (child?.icon_file && typeof child.icon_file === 'string') {
    const trimmedIcon = child.icon_file.trim();
    if (trimmedIcon && trimmedIcon !== 'null' && trimmedIcon !== 'undefined') {
      if (trimmedIcon.startsWith('http://') || trimmedIcon.startsWith('https://') || trimmedIcon.startsWith('/')) {
        return trimmedIcon;
      }
      return `${getPublicAssetBase()}/images/menus/large/${trimmedIcon}`;
    }
  }

  const verticalStrips = [
    '1792396995.jpg', '1792398507.png', '1792397652.jpg', '1792397680.jpg',
    '1792397694.jpg', '1792397708.jpg', 'mhdt.jpg', 'ldt.png',
    'mini_truck.jpg', 'pickup.jpg', 'van.jpg', 'bus.jpg',
  ];
  if (child?.image && typeof child.image === 'string') {
    const trimmed = child.image.trim();
    const basename = trimmed.split('/').pop();
    if (!verticalStrips.includes(basename)) {
      if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/')) {
        return trimmed;
      }
      return `${getPublicAssetBase()}/images/menus/large/${trimmed}`;
    }
  }

  return PRODUCT_CARD_IMAGES[slug] || '/Images/Card-img/AUMARK-S-ICON.webp';
};

const getMenuProductFallbackSrc = (child) => {
  const slug = (child?.slug || '').toLowerCase();
  return PRODUCT_CARD_IMAGES[slug] || '/Images/Card-img/AUMARK-S-ICON.webp';
};

/** Same target link rules as Navbar Products mega menu */
const getMenuProductTargetLink = (child) => {
  const target = child?.link || child?.slug || '';
  const slug = (child?.slug || '').toLowerCase();
  const link = (child?.link || '').toLowerCase();

  if (slug === 'showrooms-service' || link === 'show-rooms' || slug === 'showrooms') {
    return '/show-rooms';
  }
  if (VEHICLE_CATEGORY_SLUGS.has(slug)) {
    return `/vehicles/${slug}`;
  }
  if (!target) return '/vehicles';
  if (target.startsWith('http://') || target.startsWith('https://')) return target;
  if (target.startsWith('/vechile-details/')) return target;
  if (target.startsWith('/vehicles/')) return target;
  if (target.startsWith('vehicles/')) return `/${target}`;
  if (target.startsWith('/')) return target;
  return `/vehicles/${target}`;
};

/** Build vehicle categories from getMenus — same source as Products nav */
const extractVehicleCategoriesFromMenus = (menus) => {
  if (!Array.isArray(menus) || menus.length === 0) return [];

  const productsMenu = menus.find(
    (m) =>
      m.id === 3 ||
      m.slug === 'models' ||
      (m.menu_name_en && String(m.menu_name_en).toLowerCase().includes('product'))
  );
  const children = productsMenu?.children || [];

  const standalone = menus.filter(
    (m) =>
      (m.menu_type === 1 ||
        ['mini-truck', 'van', 'mini-bus', 'pickup', 'light-duty-trucks', 'medium-duty-truck'].includes(m.slug)) &&
      !children.some((c) => c.id === m.id || c.slug === m.slug)
  );

  const combined = [...children, ...standalone]
    .filter((item) => {
      if (!item) return false;
      if (item.status !== undefined && Number(item.status) !== 1) return false;
      if (item.front_end_menu_status !== undefined && Number(item.front_end_menu_status) !== 1) return false;
      const slug = (item.slug || '').toLowerCase();
      const link = (item.link || '').toLowerCase();
      if (NON_VEHICLE_MENU_SLUGS.has(slug) || NON_VEHICLE_MENU_SLUGS.has(link)) return false;
      return true;
    })
    .sort((a, b) => (parseInt(a.sort, 10) || 999) - (parseInt(b.sort, 10) || 999));

  return combined.map((item) => {
    const slug = (item.slug || item.link || '').toLowerCase();
    const base = BASE_CATEGORIES.find(
      (c) => c.slug === slug || c.slug === SLUG_ALIASES[slug] || c.id === item.id
    );
    return {
      id: item.id || slug,
      slug: slug || base?.slug,
      name_en: item.menu_name_en || base?.name_en || slug,
      name_ar: item.menu_name_ar || base?.name_ar || item.menu_name_en || slug,
      tag_en: base?.tag_en || '',
      tag_ar: base?.tag_ar || '',
      desc_en: cleanHtml(item.short_description_en || item.description_en || '') || base?.desc_en || '',
      desc_ar: cleanHtml(item.short_description_ar || item.description_ar || '') || base?.desc_ar || '',
      image: getMenuProductImageSrc(item),
      fallbackSrc: getMenuProductFallbackSrc(item),
      features_en: base?.features_en || [],
      features_ar: base?.features_ar || [],
      targetLink: getMenuProductTargetLink(item),
      btn_en: base?.btn_en || 'EXPLORE MODELS',
      btn_ar: base?.btn_ar || 'استكشف الطرازات',
      models_count_en: '',
      models_count_ar: '',
      sort: parseInt(item.sort, 10) || base?.sort || 999,
    };
  });
};

const cleanDisplayText = (value) => {
  if (!value || typeof value !== 'string') return '';
  const cleaned = cleanHtml(value).trim();
  if (!cleaned || cleaned === '-' || cleaned === '—' || cleaned === '–') return '';
  return cleaned;
};

function Subcomponents() {
  const [lang] = useContext(store);
  const [pageData, setPageData] = useState(null);
  const [categoriesList, setCategoriesList] = useState(BASE_CATEGORIES);
  const [heroData, setHeroData] = useState({
    title_en: "FOTON VEHICLE CATEGORIES",
    title_ar: "فئات مركبات فوتون",
    desc_en: "Explore Foton's comprehensive lineup of high-performance commercial vehicles, trucks, vans, and pickups engineered for Oman's toughest demands.",
    desc_ar: "استكشف مجموعة فوتون المتكاملة من المركبات التجارية عالية الأداء والشاحنات والفانات وسيارات البيك أب المصممة لأقسى المتطلبات في عمان."
  });
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const pathParts = location.pathname.split('/').filter(Boolean);
  const rawSlug = pathParts.length > 1 ? pathParts[1] : (pathParts[0] === 'vehicles' ? '' : pathParts[0] || '');
  const vehicle_slug = (rawSlug || '').toLowerCase();
  const isCategoriesPage = !vehicle_slug || vehicle_slug === 'vehicles';

  useEffect(() => {
    setLoading(true);

    if (isCategoriesPage) {
      const menusEndpoint = apiUrl ? `${apiUrl}getMenus` : 'https://dev10.sbagh.com/api/getMenus';
      const homeEndpoint = apiUrl ? `${apiUrl}getHomePageDataBySlug/home` : 'https://dev10.sbagh.com/api/getHomePageDataBySlug/home';

      Promise.all([
        axios.get(menusEndpoint).catch((err) => {
          console.warn('Could not load menus for /vehicles:', err?.message);
          return null;
        }),
        axios.get(homeEndpoint).catch(() => null),
      ])
        .then(([menusRes, homeRes]) => {
          const menus = menusRes?.data?.data?.menus || [];
          const productsMenu = menus.find((m) => m.id === 3 || m.slug === 'models');
          const sectionTitle = homeRes?.data?.data?.foton_products?.section_title?.[0];
          const homeProducts = homeRes?.data?.data?.foton_products?.products || [];

          setHeroData({
            title_en:
              sectionTitle?.category_title_en ||
              productsMenu?.menu_name_en ||
              'FOTON PRODUCTS',
            title_ar:
              sectionTitle?.category_title_ar ||
              productsMenu?.menu_name_ar ||
              'منتجات فوتون',
            desc_en:
              cleanHtml(sectionTitle?.highlight_en) ||
              'With all series Commercial Vehicle business, Foton Motor is one of the leading Commercial Vehicle manufactures in the world.',
            desc_ar:
              cleanHtml(sectionTitle?.highlight_ar) ||
              'مع جميع سلاسل أعمال المركبات التجارية، تعد شركة Foton Motor واحدة من الشركات الرائدة في تصنيع المركبات التجارية في العالم.',
          });

          let categories = extractVehicleCategoriesFromMenus(menus);

          // Enrich copy from home foton_products when menus lack descriptions
          if (categories.length > 0 && Array.isArray(homeProducts) && homeProducts.length > 0) {
            categories = categories.map((cat) => {
              const remote = homeProducts.find(
                (rp) =>
                  rp.slug === cat.slug ||
                  rp.link === cat.slug ||
                  rp.id === cat.id ||
                  SLUG_ALIASES[rp.slug] === cat.slug
              );
              if (!remote) return cat;
              return {
                ...cat,
                name_en: cat.name_en || remote.menu_name_en,
                name_ar: cat.name_ar || remote.menu_name_ar,
                desc_en: cat.desc_en || cleanHtml(remote.short_description_en) || cat.desc_en,
                desc_ar: cat.desc_ar || cleanHtml(remote.short_description_ar) || cat.desc_ar,
              };
            });
          }

          setCategoriesList(categories.length > 0 ? categories : BASE_CATEGORIES);
        })
        .catch((err) => {
          console.warn('Could not load dynamic categories, using base list:', err?.message);
          setCategoriesList(BASE_CATEGORIES);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      const targetSlug = SLUG_ALIASES[vehicle_slug] || vehicle_slug;
      const remoteUrl = apiUrl
        ? `${apiUrl}getProductsDataByProductCategorySlug/${targetSlug}`
        : `https://dev10.sbagh.com/api/getProductsDataByProductCategorySlug/${targetSlug}`;
      const localUrl = `http://localhost/foton-oman-backend/api/getProductsDataByProductCategorySlug/${targetSlug}`;
      // Prefer configured remote API so CMS product/category updates show on local frontend
      const primaryUrl = remoteUrl;
      const fallbackUrl = isLocalEnv() ? localUrl : remoteUrl;

      const processCategoryResponse = (response) => {
        const data = response?.data?.data;
        if (data && typeof data === 'object' && !Array.isArray(data) && data.title) {
          // Use CMS title as-is (no hardcoded category title overrides)
          const titleObj = data.title;
          const contentList = Array.isArray(data.content) ? data.content : [];

          setPageData({
            ...data,
            title: titleObj,
            content: contentList
          });
          return true;
        }
        return false;
      };

      axios.get(primaryUrl)
        .then((response) => {
          if (!processCategoryResponse(response)) {
            return axios.get(fallbackUrl).then((fbRes) => {
              if (!processCategoryResponse(fbRes)) {
                const fallback = FALLBACK_CATEGORIES[vehicle_slug] ||
                  FALLBACK_CATEGORIES[targetSlug] ||
                  FALLBACK_CATEGORIES['light-duty-trucks'];
                setPageData(fallback);
              }
            });
          }
        })
        .catch((error) => {
          console.warn("Could not load from primary category endpoint, trying fallback:", error?.message);
          return axios.get(fallbackUrl)
            .then((response) => {
              if (!processCategoryResponse(response)) {
                const fallback = FALLBACK_CATEGORIES[vehicle_slug] ||
                  FALLBACK_CATEGORIES[targetSlug] ||
                  FALLBACK_CATEGORIES['light-duty-trucks'];
                setPageData(fallback);
              }
            })
            .catch((fbErr) => {
              console.error("Error fetching category products:", fbErr);
              const fallback = FALLBACK_CATEGORIES[vehicle_slug] ||
                FALLBACK_CATEGORIES[targetSlug] ||
                FALLBACK_CATEGORIES['light-duty-trucks'];
              setPageData(fallback);
            });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [location.pathname, vehicle_slug, isCategoriesPage]);

  if (loading) {
    return (
      <>
        <LoaderComponent />
        <Footer />
      </>
    );
  }

  // ================= RENDER CATEGORIES PAGE (/vehicles) =================
  if (isCategoriesPage) {
    const pageTitle = lang ? (heroData.title_ar || "فئات المركبات") : (heroData.title_en || "FOTON VEHICLE CATEGORIES");
    const pageDesc = lang ? (heroData.desc_ar || "") : (heroData.desc_en || "");

    return (
      <div className={`vc-page-wrapper ${lang ? 'vc-rtl' : 'vc-ltr'}`}>
        <Helmet>
          <title>{lang ? 'فئات المركبات | فوتون عمان' : 'Vehicle Categories | Foton Oman'}</title>
          <meta name="description" content={pageDesc} />
        </Helmet>

        {/* HERO BANNER */}
        <section
          className="vc-hero"
          style={{
            backgroundImage: `linear-gradient(${lang ? '270deg' : '90deg'}, rgba(8, 20, 38, 0.55) 0%, rgba(8, 20, 38, 0.28) 38%, rgba(8, 20, 38, 0.08) 68%, rgba(8, 20, 38, 0) 100%), url('${FOTON_FAMILY_BANNER_URL}')`,
            backgroundPosition: lang ? 'center left' : 'center right'
          }}
        >
          <div className="vc-hero-content">
            <div className="vc-breadcrumb">
              <Link to="/">{lang ? 'الرئيسية' : 'HOME'}</Link>
              <span className="vc-sep">{lang ? '<' : '/'}</span>
              <span>{lang ? 'المركبات' : 'VEHICLES'}</span>
            </div>

            <div className="vc-hero-tag">
              {lang ? 'مجموعة فوتون الكاملة' : 'FOTON COMMERCIAL RANGE'}
            </div>

            <h1 className="vc-hero-title">
              {pageTitle}
            </h1>

            <p className="vc-hero-desc">
              {pageDesc}
            </p>
          </div>
        </section>

        {/* CATEGORIES GRID */}
        <div className="vc-grid-section">
          <div className="vc-grid-header">
            <div className="vc-grid-count">
              <strong>{categoriesList.length}</strong> {lang ? 'فئات متوفرة' : 'CATEGORIES AVAILABLE'}
            </div>
          </div>

          <Row>
            {categoriesList.map((category, index) => {
              const displayName = lang ? (category.name_ar || category.name_en) : (category.name_en || category.name_ar);

              return (
                <Col
                  lg={4}
                  md={6}
                  sm={12}
                  key={category.id || category.slug}
                  className="vc-col"
                  data-aos="fade-up"
                  data-aos-delay={(index % 3) * 100}
                >
                  <Link
                    to={category.targetLink || `/vehicles/${category.slug}`}
                    className="vc-card vc-card--simple"
                  >
                    <div className="vc-img-wrap">
                      <img
                        src={category.image}
                        alt={displayName}
                        className="vc-vehicle-img"
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = category.fallbackSrc || '/Images/Card-img/AUMARK-S-ICON.webp';
                        }}
                      />
                    </div>

                    <div className="vc-card-title-row">
                      <h3 className="vc-card-title">{displayName}</h3>
                      {/* Foton motor-style: two arrows in clipped track — hover slides one out as the next enters */}
                      <span className="vc-card-arrow" aria-hidden="true">
                        <span className="vc-card-arrow-track">
                          <span className="vc-card-arrow-icon">{lang ? <FaArrowLeft /> : <FaArrowRight />}</span>
                          <span className="vc-card-arrow-icon">{lang ? <FaArrowLeft /> : <FaArrowRight />}</span>
                        </span>
                      </span>
                    </div>
                  </Link>
                </Col>
              );
            })}
          </Row>
        </div>

        <NextSteps />
        <Footer />
      </div>
    );
  }

  // ================= RENDER SPECIFIC CATEGORY PRODUCTS PAGE (/vehicles/:slug) =================
  const categoryTitle = lang
    ? (pageData?.title?.menu_name_ar || pageData?.title?.name_ar || "المركبات")
    : (pageData?.title?.menu_name_en || pageData?.title?.name_en || vehicle_slug.replace(/-/g, ' ').toUpperCase());

  const productsList = Array.isArray(pageData?.content)
    ? pageData.content
    : (FALLBACK_CATEGORIES[vehicle_slug]?.content || []);

  // If the category has only 1 product, redirect to that product's details (slug from API/CMS)
  if (productsList.length === 1) {
    const singleProduct = productsList[0];
    const detailSlug = singleProduct.product_name_slug || singleProduct.slug || singleProduct.link;
    if (detailSlug) {
      return <Navigate to={`/vechile-details/${detailSlug}`} replace />;
    }
  }

  const categoryHeroImage = CATEGORY_HERO_IMAGES[vehicle_slug] || FOTON_FAMILY_BANNER_URL;

  return (
    <div className={`vc-page-wrapper ${lang ? 'vc-rtl' : 'vc-ltr'}`}>
      <Helmet>
        <title>{`${categoryTitle} | ${lang ? 'فوتون عمان' : 'Foton Oman'}`}</title>
      </Helmet>

      {/* CATEGORY HERO */}
      <section
        className={`vc-hero${categoryHeroImage === FOTON_FAMILY_BANNER_URL ? '' : ' vc-hero--tall'}`}
        style={{
          backgroundImage: `linear-gradient(${lang ? '270deg' : '90deg'}, rgba(8, 20, 38, 0.55) 0%, rgba(8, 20, 38, 0.28) 38%, rgba(8, 20, 38, 0.08) 68%, rgba(8, 20, 38, 0) 100%), url('${categoryHeroImage}')`,
          backgroundPosition: 'center center'
        }}
      >
        <div className="vc-hero-content">
          {/* <div className="vc-breadcrumb">
            <Link to="/">{lang ? 'الرئيسية' : 'HOME'}</Link>
            <span className="vc-sep">{lang ? '<' : '/'}</span>
            <Link to="/vehicles">{lang ? 'المركبات' : 'VEHICLES'}</Link>
            <span className="vc-sep">{lang ? '<' : '/'}</span>
            <span>{categoryTitle}</span>
          </div> */}

          {/* <div className="vc-hero-tag">
            {lang ? 'فئة المركبات' : 'VEHICLE CATEGORY'}
          </div> */}

          <h1 className="vc-hero-title">
            {categoryTitle}
          </h1>

          <p className="vc-hero-desc">
            {cleanDisplayText(lang
              ? (pageData?.title?.short_description_ar || pageData?.title?.description_ar || pageData?.title?.highlight_ar)
              : (pageData?.title?.short_description_en || pageData?.title?.description_en || pageData?.title?.highlight_en)
            ) || (lang
              ? "استكشف طرازات ومواصفات المركبات المتطورة المصممة لأداء وكفاءة استثنائية."
              : "Discover state-of-the-art Pickup models and specifications engineered for exceptional performance and efficiency.")}
          </p>
        </div>
      </section>

      {/* PRODUCTS LISTING GRID */}
      <div className="vc-grid-section">
        <div className="vc-grid-header">
          <div className="vc-grid-count">
            <strong>{productsList.length}</strong> {lang ? 'طرازات متوفرة' : 'MODELS AVAILABLE'}
          </div>
        </div>

        {productsList.length > 0 ? (
          <Row>
            {productsList.map((item, index) => {
              const displayName = lang ? (item.product_name_ar || item.product_name_en) : (item.product_name_en || item.product_name_ar);
              const displayDesc = cleanDisplayText(
                lang ? (item.short_description_ar || item.short_description_en) : (item.short_description_en || item.short_description_ar)
              );
              const detailSlug = item.product_name_slug || item.slug || item.link || item.id;
              const useCategoryCard = vehicle_slug === 'pickup';

              return (
                <Col
                  lg={4}
                  md={6}
                  sm={12}
                  key={item.id || detailSlug || index}
                  className="vc-col"
                  data-aos="fade-up"
                  data-aos-delay={(index % 3) * 100}
                >
                  {useCategoryCard ? (
                    <Link
                      to={"/vechile-details/" + detailSlug}
                      className="vc-card vc-card--simple"
                    >
                      <div className="vc-img-wrap">
                        <img
                          src={getProductImageUrl(item.product_image)}
                          alt={displayName}
                          className="vc-vehicle-img"
                          loading="lazy"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/Images/Card-img/TUNLAND-ICON0.webp';
                          }}
                        />
                      </div>

                      <div className="vc-card-title-row">
                        <h3 className="vc-card-title">{displayName}</h3>
                        <span className="vc-card-arrow" aria-hidden="true">
                          <span className="vc-card-arrow-track">
                            <span className="vc-card-arrow-icon">{lang ? <FaArrowLeft /> : <FaArrowRight />}</span>
                            <span className="vc-card-arrow-icon">{lang ? <FaArrowLeft /> : <FaArrowRight />}</span>
                          </span>
                        </span>
                      </div>
                    </Link>
                  ) : (
                    <div className="vc-card">
                      <div className="vc-card-topbar">
                        <span className="vc-category-tag">{categoryTitle}</span>
                        <span className="vc-models-count">FOTON</span>
                      </div>

                      <div className="vc-img-wrap">
                        <img
                          src={getProductImageUrl(item.product_image)}
                          alt={displayName}
                          className="vc-vehicle-img"
                          loading="lazy"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/Images/Card-img/TUNLAND-ICON0.webp';
                          }}
                        />
                      </div>

                      <div className="vc-card-body">
                        <h3 className="vc-card-title">{displayName}</h3>
                        <p className="vc-card-desc">{displayDesc || (lang ? "مركبة تجارية متطورة من فوتون." : "Advanced commercial vehicle from Foton.")}</p>

                        <div className="vc-card-footer">
                          <Link to={"/vechile-details/" + detailSlug} className="vc-btn-explore">
                            <span>{lang ? "عرض التفاصيل" : "VIEW DETAILS"}</span>
                            {lang ? <FaArrowLeft className="vc-btn-icon" /> : <FaArrowRight className="vc-btn-icon" />}
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              );
            })}
          </Row>
        ) : (
          <div className="text-center py-5 my-5">
            <p className="text-muted fs-5">
              {lang ? "لا توجد مركبات متوفرة حالياً في هذا القسم" : "No vehicles currently available in this category"}
            </p>
            <Link to="/vehicles" className="btn btn-outline-primary mt-3">
              {lang ? "العودة إلى جميع الفئات" : "Back to All Categories"}
            </Link>
          </div>
        )}
      </div>

      <NextSteps />
      <Footer />
    </div>
  );
}

export default Subcomponents;
